import { Button, FormControl, InputLabel, MenuItem, Select, TextField } from "@mui/material";
import styles from "./updatecompanyform.module.css";
import axios from "axios";
import { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { authData } from "../../components/GetAuth";
import { NumericFormat } from "react-number-format";
import { CountryList } from "../../components/Constants";
import { useState, useRef } from "react";

const UpdateCompanyForm = ({ setFormOpen, onLocal, setSnackbarOpen, setSnackbarMessage, setSnackbarType, setLoading, editData }) => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const inputRef = useRef(null);

  const { register, handleSubmit, control, setValue, watch, formState: { errors } } = useForm({
    mode: "onChange",
    defaultValues: {
      tax_title: "Tax",
      pickup_country: "",
      delivery_country: "",
    },
  });

  useEffect(() => {
    if (editData) {
      setValue("address", editData?.address === '' ? editData?.company_address : editData?.address);
      setValue("insurance_charges", editData?.insurance_charges);
      setValue("city", editData?.city);
      setValue("zip", editData?.zip);
      setValue("state", editData?.state);
      setValue("payment_receiver_account", editData?.payment_receiver_account);
      setValue("payment_receiver_code", editData?.payment_receiver_code);
      setValue("payment_receiver_name", editData?.payment_receiver_name);
      setValue("reg_number", editData?.reg_number);
      setValue("tax_charges", editData?.tax_charges);
      setValue("terms_condition", editData?.terms_condition);
      setValue("vat_number", editData?.vat_number);
      setValue("company_name", editData?.company_name);
      setValue("name", editData?.name);
      setValue("email", editData?.email);
      setValue("phone", editData?.phone);
      setValue("tax_title", editData?.tax_title);
      setValue("pickup_country", editData?.pickup_country);
      setValue("delivery_country", editData?.delivery_country);
      setValue("reference_amount", editData?.reference_amount);

      if (editData?.tax_charges > 0)
        setValue("tax_charges", editData?.tax_charges);
      if (editData?.insurance_charges > 0)
        setValue("insurance_charges", editData?.insurance_charges);

      if (editData?.logo_url) {
        setPreview(editData?.logo_url);
      }
    }
  }, [editData, setValue]);

  const onSubmit = (data) => {
    const formData = new FormData();

    if (image) {
      formData.append("image", image);
    }

    if (data?.address) {
      formData.append("address", data?.address);
    }

    if (data?.city) {
      formData.append("city", data?.city);
    }

    if (data?.company_name) {
      formData.append("company_name", data?.company_name);
    }

    if (data?.delivery_country) {
      formData.append("delivery_country", data?.delivery_country);
    }

    if (data?.insurance_charges) {
      formData.append("insurance_charges", data?.insurance_charges);
    }

    if (data?.name) {
      formData.append("name", data?.name);
    }

    if (data?.payment_receiver_account) {
      formData.append("payment_receiver_account", data?.payment_receiver_account);
    }

    if (data?.payment_receiver_code) {
      formData.append("payment_receiver_code", data?.payment_receiver_code);
    }

    if (data?.payment_receiver_name) {
      formData.append("payment_receiver_name", data?.payment_receiver_name);
    }

    if (data?.phone) {
      formData.append("phone", data?.phone);
    }

    if (data?.pickup_country) {
      formData.append("pickup_country", data?.pickup_country);
    }

    if (data?.reference_amount) {
      formData.append("reference_amount", data?.reference_amount);
    }

    if (data?.reg_number) {
      formData.append("reg_number", data?.reg_number);
    }

    if (data?.state) {
      formData.append("state", data?.state);
    }

    if (data?.city) {
      formData.append("tax_charges", data?.tax_charges);
    }

    if (data?.tax_title) {
      formData.append("tax_title", data?.tax_title);
    }

    if (data?.terms_condition) {
      formData.append("terms_condition", data?.terms_condition);
    }

    if (data?.vat_number) {
      formData.append("vat_number", data?.vat_number);
    }

    if (data?.zip) {
      formData.append("zip", data?.zip);
    }

    setLoading(true);
    setFormOpen(false);


    axios.post(process.env.REACT_APP_API_URL + "v1/companies/" + editData?.id, formData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setLoading(false);
      if (response.data.status === "SUCCESS") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("success");

        onLocal(response.data.data);
      }

      if (response.data.status === "ERROR") {
        setSnackbarOpen(true);
        setSnackbarMessage(response.data.message);
        setSnackbarType("error");
      }
    }).catch((error) => {
      setLoading(false);
      if (error && error.response && error.response.data && error.response.data.messages) {
        setSnackbarOpen(true);
        setSnackbarMessage(error.response.data.messages);
        setSnackbarType("error");
      }
    });

  }

  const handleFileChange = (e) => {
    let file = e.target.files[0];
    handleFile(file);
  }

  const handleDrop = (e) => {
    e.preventDefault();
    handleFile(e.dataTransfer.files[0]);
  }

  const handleFile = (file) => {
    if (!file) return;

    if (!["image/jpeg", "image/png"].includes(file.type)) {
      setSnackbarType('error');
      setSnackbarOpen(true);
      setSnackbarMessage('Only JPG & PNG allowed');
      return;
    }

    if (file.size > 2 * 1024 * 1024) {
      setSnackbarType('error');
      setSnackbarOpen(true);
      setSnackbarMessage("Max file size is 2MB");
      return;
    }

    setPreview(URL.createObjectURL(file));
    setImage(file);
  }

  return (<form onSubmit={handleSubmit(onSubmit)}>
    <div className={`${styles.FormMainRow}`}>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("company_name", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Company Name*" variant="outlined" />)}
        />
        {errors.company_name && (<span className={`ErrorM`}>{errors?.Company_name?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("reg_number")}
          render={({ field }) => (<TextField {...field} label="Register No" variant="outlined" />)}
        />
        {errors.reg_number && (<span className={`ErrorM`}>{errors?.reg_number?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("address", {
            required: "This field is Required",
          })}
          render={({ field }) => (<TextField {...field} label="Address*" variant="outlined" />)}
        />
        {errors.address && (<span className={`ErrorM`}>{errors?.address?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("city")}
          render={({ field }) => (<TextField {...field} label="City" variant="outlined" />)}
        />
        {errors.city && (<span className={`ErrorM`}>{errors?.city?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("state")}
          render={({ field }) => (<TextField {...field} label="State" variant="outlined" />)}
        />
        {errors.state && (<span className={`ErrorM`}>{errors?.state?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("zip")}
          render={({ field }) => (<TextField {...field} label="Post code" variant="outlined" />)}
        />
        {errors.zip && (<span className={`ErrorM`}>{errors?.zip?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("name", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Owner Name*" variant="outlined" />)}
        />
        {errors.name && (<span className={`ErrorM`}>{errors?.name?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("email", {
            required: "This field is Required",
            pattern: {
              value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
              message: "Invalid email address",
            },
          })}
          render={({ field }) => (<TextField {...field} label="Email*" variant="outlined" />)}
        />
        {errors.email && (<span className={`ErrorM`}>{errors?.email?.message}</span>)}
      </div>

      {!editData && (<>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("password", {
              required: "This field is Required",
            })}
            control={control}
            render={({ field }) => (<TextField {...field} label="Password*" variant="outlined" type="password" />)}
          />
          {errors.password && (<span className={`ErrorM`}>{errors?.password?.message}</span>)}
        </div>
        <div className={`${styles.FormGroupHalf} FormGroup`}>
          <Controller
            {...register("conf_password", {
              required: "This field is Required",
              validate: (val) => {
                if (watch("password") !== val) {
                  return "Your passwords do no match";
                }
              },
            })}
            control={control}
            render={({ field }) => (<TextField {...field} id="outlined-basic" label="Confirm Password*" variant="outlined" type="password" />)}
          />
          {errors.conf_password && (<span className={`ErrorM`}>{errors?.conf_password?.message}</span>)}
        </div>
      </>)}

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("phone", { required: "This field is Required", })}
          render={({ field }) => (<TextField {...field} label="Phone*" variant="outlined" />)}
        />
        {errors.phone && (<span className={`ErrorM`}>{errors.phone.message}</span>)}
      </div>



      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("vat_number")}
          render={({ field }) => (<TextField {...field} label="Vat Number" variant="outlined" />)}
        />
        {errors.vat_number && (<span className={`ErrorM`}>{errors?.vat_number?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_name")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Name" variant="outlined" />)}
        />
        {errors.payment_receiver_name && (<span className={`ErrorM`}>{errors?.payment_receiver_name?.message}</span>)}
      </div>


      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_account")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Account" variant="outlined" />)}
        />
        {errors.payment_receiver_account && (<span className={`ErrorM`}>{errors?.payment_receiver_account?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("payment_receiver_code")}
          render={({ field }) => (<TextField {...field} label="Payment Receiver Code" variant="outlined" />)}
        />
        {errors.payment_receiver_code && (<span className={`ErrorM`}>{errors?.payment_receiver_code?.message}</span>)}
      </div>



      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_title", { required: "This field is Required" })}
          render={({ field }) => (<TextField {...field} label="Tax Title*" variant="outlined" />)}
        />
        {errors.tax_title && (<span className={`ErrorM`}>{errors?.tax_title?.message}</span>)}
      </div>



      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("tax_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Tax Charges(%)" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.tax_charges && (<span className={`ErrorM`}>{errors?.tax_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("insurance_charges")}
          render={({ field }) => (<NumericFormat {...field} label="Insurance Charges" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.insurance_charges && (<span className={`ErrorM`}>{errors?.insurance_charges?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Pickup Country*</InputLabel>
          <Controller
            control={control}
            {...register("pickup_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Pickup Country*" {...field}>
              <MenuItem value={"GB"}>United Kingdom</MenuItem>
            </Select>)}
          />
        </FormControl>
        {errors.pickup_country && (<span className={`ErrorM`}>{errors?.pickup_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Delivery Country*</InputLabel>
          <Controller
            control={control}
            {...register("delivery_country", {
              required: "This field is required",
            })}
            render={({ field }) => (<Select label="Delivery Country*" {...field}>
              {CountryList?.map((i) => {
                return (<MenuItem key={i?.value} value={i?.value}>{i?.label}</MenuItem>);
              })}
            </Select>)}
          />
        </FormControl>
        {errors.delivery_country && (<span className={`ErrorM`}>{errors?.delivery_country?.message}</span>)}
      </div>
      <div className={`${styles.FormGroupHalf} FormGroup`}>
        <Controller
          control={control}
          {...register("reference_amount")}
          render={({ field }) => (<NumericFormat {...field} label="Reference Amount" variant="outlined" customInput={TextField} allowLeadingZeros={false} allowNegative={false} decimalScale={2} fixedDecimalScale />)}
        />
        {errors.reference_amount && (<span className={`ErrorM`}>{errors?.reference_amount?.message}</span>)}
      </div>

      <div className={`${styles.FormGroupFull} FormGroup`}>
        <Controller
          control={control}
          {...register("terms_condition")}
          render={({ field }) => (<TextField {...field} label="Terms & Condition" variant="outlined" multiline minRows={4} />)}
        />
        {errors.terms_condition && (<span className={`ErrorM`}>{errors?.terms_condition?.message}</span>)}
      </div>

      <div onDragOver={(e) => e.preventDefault()}
        onDrop={handleDrop}
        style={{
          border: "2px dashed #ccc",
          padding: "20px",
          textAlign: "center",
          borderRadius: "8px",
          width: '100%'
        }}>
        <input ref={inputRef} accept="image/jpeg, image/png" tabindex="-1" type="file" style={{ display: 'none' }} onChange={handleFileChange} />
        <b>Drag and drop images or <button
          type="button"
          onClick={() => inputRef.current.click()}
          style={{
            color: "#2563eb",
            background: "none",
            border: "none",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >Choose a file</button></b>
        <p style={{ fontSize: '14px', fontWeight: 400, color: '#64748b', margin: 0 }}>Supported format: image/jpeg, image/png</p>
        <p style={{ fontSize: '14px', fontWeight: 400, color: '#64748b', margin: 0 }}>Maximum size: 2MB</p>
      </div>

      {preview && (<div style={{ marginTop: "15px", border: '1px solid rgb(204, 204, 204)', padding: '10px', borderRadius: '5px', width: '100%' }}>
        <img src={preview} alt="preview" style={{ width: "150px", borderRadius: "8px" }} />
      </div>)}
    </div>

    <div className="ButtonAction">
      <Button className="CancelPopupBU" onClick={(e) => setFormOpen(false)}>Cancel</Button>
      <Button className="SubmitPopupBU" type="submit">Update</Button>
    </div>
  </form>);
};

export default UpdateCompanyForm;